
import recomende from './RecomendeReducer';

export default recomende;
